(() => {
  if (window.campaignNav) {
    window.campaignNav.init(document);
    return;
  }

  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  const escapeAttrValue = (value) => {
    if (typeof CSS !== "undefined" && typeof CSS.escape === "function") {
      return CSS.escape(value);
    }
    return value.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
  };

  const findTargetEl = (key) => {
    if (!key) return null;
    return (
      document.querySelector(`[data-nav-target="${escapeAttrValue(key)}"]`) ||
      document.getElementById(key)
    );
  };

  const getVisibleLabel = (link) => {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    const selector = isMobile ? ".campaign-nav__label.hide-pc" : ".campaign-nav__label.hide-mb";
    const el = link.querySelector(selector) || link.querySelector(".campaign-nav__label");
    return (el?.textContent || link.textContent || "").replace(/\s+/g, " ").trim();
  };

  const getSections = (links) =>
    links
      .map((link) => {
        const id = link.dataset.campaignNavTarget;
        if (!id) return null;
        const el = findTargetEl(id);
        return el ? { link, el, id } : null;
      })
      .filter(Boolean);

  const setup = (nav) => {
    if (nav.dataset.campaignNavInitialized === "true") return;

    const track = nav.querySelector("[data-campaign-nav-track]");
    const indicator = nav.querySelector("[data-campaign-nav-indicator]");
    const links = [...nav.querySelectorAll("[data-campaign-nav-link]")];
    const sections = getSections(links);

    if (!track || !indicator || !sections.length) return;

    let activeIndex = 0;
    let ticking = false;

    const moveIndicator = (index) => {
      const item = sections[index]?.link.closest(".campaign-nav__item") || sections[index]?.link;
      if (!item) return;

      const trackRect = track.getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();
      const width = itemRect.width;
      const left = itemRect.left - trackRect.left + track.scrollLeft + width * 0.18;

      indicator.style.width = `${width * 0.64}px`;
      indicator.style.transform = `translateX(${left}px)`;
    };

    const setActive = (index) => {
      if (index < 0 || index >= sections.length) return;
      activeIndex = index;

      sections.forEach((section, i) => {
        section.link.classList.toggle("is-active", i === index);
        section.link.setAttribute("aria-current", i === index ? "true" : "false");
      });

      moveIndicator(index);
    };

    /**
     * Active once this section's top has reached ~viewport mid,
     * until the next nav target's top reaches that same line.
     */
    const updateActiveFromScroll = () => {
      const threshold = window.innerHeight * 0.5;
      let nextActive = 0;

      sections.forEach((section, index) => {
        if (section.el.getBoundingClientRect().top <= threshold) {
          nextActive = index;
        }
      });

      if (nextActive !== activeIndex) {
        setActive(nextActive);
      } else {
        moveIndicator(activeIndex);
      }
    };

    const onScrollOrResize = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        updateActiveFromScroll();
        ticking = false;
      });
    };

    const pushNavGa4 = (buttonName) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: "ga4Event",
        event_name: "select_content_category",
        event_parameters: {
          content_type: "navigation_bar",
          button_name: buttonName,
        },
      });
    };

    const scrollToSection = (index) => {
      const section = sections[index];
      if (!section) return;

      section.el.scrollIntoView({
        behavior: reduceMotion.matches ? "auto" : "smooth",
        block: "start",
      });

      setActive(index);
    };

    links.forEach((link) => {
      link.addEventListener("click", (event) => {
        const targetIndex = sections.findIndex((section) => section.link === link);
        if (targetIndex < 0) return;
        event.preventDefault();
        pushNavGa4(getVisibleLabel(link));
        scrollToSection(targetIndex);
      });
    });

    track.addEventListener("scroll", onScrollOrResize, { passive: true });
    window.addEventListener("scroll", onScrollOrResize, { passive: true });
    window.addEventListener("resize", onScrollOrResize);

    setActive(0);
    updateActiveFromScroll();

    nav.dataset.campaignNavInitialized = "true";
  };

  const init = (root = document) => {
    if (root.matches?.("[data-campaign-nav]")) {
      setup(root);
    }
    root.querySelectorAll?.("[data-campaign-nav]").forEach(setup);
  };

  document.addEventListener("shopify:section:load", (event) => {
    init(event.target);
  });

  window.campaignNav = { init };
  init();
})();
